/* eslint-disable default-param-last */
// Action types
const SET_LOADING = "spirit/utils/SET_LOADING";
const SET_MODAL = "spirit/utils/SET_MODAL";
const SET_ERROR = "spitit/utils/SET_ERROR";
const OPEN_HEADER_BOX = "spitit/utils/OPEN_HEADER_BOX";
const SET_PASSWORD_SCREEN = "spirit/utils/SET_PASSWORD_SCREEN";


// InitialState
export const initialState = {
  isLoading: { type: "" },
  isError: { type: "" },
  modal: {
    type: "",
    category: "",
  },
  openHeader: {
    type: "",
    isOpen: false,
  },
  passwordScreen: "password-reset",
 
};

// Reducers
export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        isLoading: action.info,
      };
    case SET_ERROR:
      return {
        ...state,
        isError: action.info,
      };
    case SET_MODAL:
      return {
        ...state,
        modal: action.info,
      };
    case OPEN_HEADER_BOX:
      return {
        ...state,
        openHeader: action.info,
      };
    case SET_PASSWORD_SCREEN:
      return {
        ...state,
        passwordScreen: action.info,
      };
 
    default:
      return state;
  }
};

// Action Creators
export const setLoadingType = (info) => ({
  type: SET_LOADING,
  info,
});

export const setErrorType = (info) => ({
  type: SET_ERROR,
  info,
});

export const setModal = (info) => ({
  type: SET_MODAL,
  info,
});

export const openHeaderBox = (info) => ({
  type: OPEN_HEADER_BOX,
  info,
});

export const setPasswordScreen = (info) => ({
  type: SET_PASSWORD_SCREEN,
  info,
});


